import { currency } from '../utils/helpers';
import TabSwitcher from '../modules/components/TabSwitcher';
import FormValidation from '../modules/FormValidation';
import PricingCalculator from '../modules/components/PricingCalculator';
export default class OrderPage {
    constructor() {
        this.contactTabSwitcher = null;
        this.orderForm = document.querySelector('#order-form');
        if (!this.orderForm) {
            return;
        }
        this.ajaxApiUrl = window.localize_script.admin_ajax;
        // Initialize form validation
        this.formValidation = new FormValidation(this.orderForm, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            generalErrorSelector: '#order-error-message'
        });
        this.parseViewData();
        this.initGuestCounters();
        this.initAdditionalServices();
        this.initContactTabs();
        this.initOrderSubmission();
        this.updateTotals();
    }
    initContactTabs() {
        const contactTabsElement = this.orderForm.querySelector('.underlined-tabs[data-tab-switcher]');
        if (contactTabsElement) {
            this.contactTabSwitcher = new TabSwitcher(contactTabsElement, {
                onChange: (activeTab) => {
                    const customerTypeInput = this.orderForm.querySelector('#customer-type');
                    if (customerTypeInput) {
                        customerTypeInput.value = activeTab;
                    }
                    this.formValidation.clearAllErrors();
                }
            });
        }
    }
    parseViewData() {
        const viewDataElement = document.querySelector('#view-data');
        if (viewDataElement) {
            try {
                this.viewData = JSON.parse(viewDataElement.textContent || '{}');
            }
            catch (error) {
                console.error('Error parsing view data:', error);
                this.viewData = {
                    adults_price: 0,
                    teenagers_price: 0,
                    kids_price: 0,
                    duration_days: 1,
                    dynamic_duration_days: false,
                    units: 'Units',
                    price_by_person_amount: null,
                    price_by_weekday: null
                };
            }
        }
    }
    initGuestCounters() {
        this.adultsInput = this.orderForm.querySelector('#adults');
        this.teenagersInput = this.orderForm.querySelector('#teenagers');
        this.kidsInput = this.orderForm.querySelector('#kids');
        const counterInputs = this.orderForm.querySelectorAll('.counter-controls input');
        counterInputs.forEach(input => {
            input.addEventListener('change', () => this.updateTotals());
        });
    }
    initAdditionalServices() {
        const additionalServiceInputs = this.orderForm.querySelectorAll('input[type="radio"][name^="additional_services["]');
        additionalServiceInputs.forEach(input => {
            input.addEventListener('change', () => this.updateTotals());
        });
    }
    updateTotals() {
        const guestCounts = PricingCalculator.getGuestCounts(this.orderForm);
        const durationDays = PricingCalculator.getDurationDays(this.orderForm, this.viewData);
        const reservationDate = this.orderForm.querySelector('#reservation-date');
        const groupBookingInput = this.orderForm.querySelector('#group-booking');
        const result = PricingCalculator.calculateTotal({
            viewData: this.viewData,
            guestCounts,
            durationDays,
            container: this.orderForm,
            reservationDate: reservationDate ? reservationDate.value : '',
            groupBooking: groupBookingInput && groupBookingInput.value === 'true'
        });
        this.updateGuestTotals(guestCounts.adults, guestCounts.teenagers, guestCounts.kids, durationDays);
        this.updateAdditionalServicesDisplay(result.additionalServicesTotal);
        this.updateSummaryTotals(result.finalTotal);
    }
    updateAdditionalServicesDisplay(additionalServicesTotal) {
        const additionalServicesSummary = this.orderForm.querySelector('.additional-services-summary');
        if (!additionalServicesSummary) {
            return;
        }
        additionalServicesSummary.innerHTML = '';
        if (additionalServicesTotal <= 0) {
            additionalServicesSummary.classList.add('hidden');
            return;
        }
        additionalServicesSummary.classList.remove('hidden');
        const guestCounts = PricingCalculator.getGuestCounts(this.orderForm);
        const totalGuests = guestCounts.adults + guestCounts.teenagers + guestCounts.kids;
        const durationDays = this.viewData.duration_days || 1;
        const perDayMultiplier = this.viewData.dynamic_duration_days ? durationDays : 1;
        const selectedAdditionalServices = this.orderForm.querySelectorAll('input[type="radio"][name^="additional_services["]:checked');
        const servicesByGroup = {};
        selectedAdditionalServices.forEach((input) => {
            const basePrice = parseFloat(input.getAttribute('data-price') || '0');
            const name = input.getAttribute('data-name') || '';
            const group = input.getAttribute('data-group') || 'Other';
            const useOnce = input.getAttribute('data-use-once') || '0';
            const priceType = input.getAttribute('data-price-type') || 'per_person';
            const multiplier = useOnce === '1' ? 1 : perDayMultiplier;
            const totalPrice = priceType === 'group'
                ? basePrice * multiplier
                : basePrice * totalGuests * multiplier;
            if (!servicesByGroup[group]) {
                servicesByGroup[group] = [];
            }
            servicesByGroup[group].push({ name, price: basePrice, totalPrice });
        });
        Object.keys(servicesByGroup).forEach(groupName => {
            if (servicesByGroup[groupName].length > 0) {
                const groupWrapper = document.createElement('div');
                groupWrapper.className = 'order-details-item';
                const groupHeader = document.createElement('div');
                groupHeader.className = 'order-details-item-title summary-group-header';
                groupHeader.textContent = groupName;
                groupWrapper.appendChild(groupHeader);
                servicesByGroup[groupName].forEach(service => {
                    const serviceRow = document.createElement('div');
                    serviceRow.className = 'order-details-item-value summary-row additional-service-row';
                    serviceRow.innerHTML = `
                <span class="service-name">${service.name}</span>
                <span class="service-price">${currency(service.totalPrice)}</span>
            `;
                    groupWrapper.appendChild(serviceRow);
                });
                additionalServicesSummary.appendChild(groupWrapper);
            }
        });
    }
    updateGuestTotals(adultsCount, teenagersCount, kidsCount, durationDays) {
        const adultsTotal = this.viewData.dynamic_duration_days ?
            (adultsCount * this.viewData.adults_price * durationDays) :
            (adultsCount * this.viewData.adults_price);
        const teenagersTotal = this.viewData.dynamic_duration_days ?
            (teenagersCount * this.viewData.teenagers_price * durationDays) :
            (teenagersCount * this.viewData.teenagers_price);
        const kidsTotal = this.viewData.dynamic_duration_days ?
            (kidsCount * this.viewData.kids_price * durationDays) :
            (kidsCount * this.viewData.kids_price);
        const adultCountElement = document.querySelector('.adult-count');
        const teenagerCountElement = document.querySelector('.teenager-count');
        const kidCountElement = document.querySelector('.kid-count');
        const adultTotalElement = document.querySelector('.adult-total');
        const teenagerTotalElement = document.querySelector('.teenager-total');
        const kidTotalElement = document.querySelector('.kid-total');
        if (adultCountElement)
            adultCountElement.textContent = adultsCount.toString();
        if (teenagerCountElement)
            teenagerCountElement.textContent = teenagersCount.toString();
        if (kidCountElement)
            kidCountElement.textContent = kidsCount.toString();
        if (adultTotalElement)
            adultTotalElement.textContent = currency(adultsTotal);
        if (teenagerTotalElement)
            teenagerTotalElement.textContent = currency(teenagersTotal);
        if (kidTotalElement)
            kidTotalElement.textContent = currency(kidsTotal);
        const teenagersRow = document.querySelector('.teenagers-row');
        const kidsRow = document.querySelector('.kids-row');
        if (teenagersRow) {
            if (teenagersCount > 0) {
                teenagersRow.classList.remove('hidden');
            }
            else {
                teenagersRow.classList.add('hidden');
            }
        }
        if (kidsRow) {
            if (kidsCount > 0) {
                kidsRow.classList.remove('hidden');
            }
            else {
                kidsRow.classList.add('hidden');
            }
        }
    }
    updateSummaryTotals(finalTotal) {
        const totalElement = document.querySelector('.total-price');
        if (totalElement)
            totalElement.textContent = currency(finalTotal);
    }
    initOrderSubmission() {
        this.orderForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.handleOrderSubmission();
        });
    }
    handleOrderSubmission() {
        this.formValidation.clearAllErrors();
        const submitButton = this.orderForm.querySelector('button[type="submit"]');
        const originalText = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = 'Processing...';
        const formData = new FormData(this.orderForm);
        formData.append('lang', document.documentElement.lang.split('-')[0]);
        fetch(this.ajaxApiUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
            .then((response) => response.json())
            .then((data) => {
            var _a, _b;
            if (data.success) {
                window.location.href = data.data.redirect_url;
            }
            else {
                if ((_a = data.data) === null || _a === void 0 ? void 0 : _a.errors) {
                    this.formValidation.showErrors(data);
                }
                else {
                    this.formValidation.showGeneralError(((_b = data.data) === null || _b === void 0 ? void 0 : _b.message) ||
                        this.orderForm.getAttribute('data-error-process') ||
                        'An error occurred while processing your order.');
                }
                submitButton.disabled = false;
                submitButton.textContent = originalText;
            }
        })
            .catch((error) => {
            this.formValidation.showGeneralError(this.orderForm.getAttribute('data-error-generic') ||
                'An error occurred. Please try again later.');
            submitButton.disabled = false;
            submitButton.textContent = originalText;
        });
    }
}
